<template>
  <div class="facility">
    <v-container>
      <v-row class="mt-2" justify="center">

        <v-col cols="2" class="hidden-sm-and-down">
          <v-list class="mt-2 submenu" color="#fafafa" subheader dense>
            <v-subheader>目次</v-subheader>
            <v-list-item @click="smoothScroll('room1')">研究室1</v-list-item>
            <v-list-item @click="smoothScroll('room2')">研究室2</v-list-item>
            <v-list-item @click="smoothScroll('room3')">研究室3</v-list-item>
            <v-list-item @click="smoothScroll('server')">サーバ室</v-list-item>
            <v-list-item @click="smoothScroll('zemi')">ゼミ室</v-list-item>
            <v-list-item @click="smoothScroll('szemi')">小グループゼミ室</v-list-item>
            <v-list-item @click="smoothScroll('device')">機器</v-list-item>
          </v-list>
        </v-col>

        <v-col cols="10">
          <v-row v-for="room in rooms" :key="room.id" class="mt-2" justify="center">
            <v-col cols="12" md="10">
              <div :id="room.id" style="padding-top: 20px;" class="heading text-h4 pl-4 mt-8">
                {{ room.title }}
              </div>
              <v-row v-if="room.id != 'device'" class="my-4" justify="center">
                <v-col  cols="12" md="6" v-for="image in room.images" :key="image">
                  <v-img :src="image" eager></v-img>
                </v-col>
              </v-row>
              <p v-html="room.description"></p>
              <template v-if="room.id == 'device'">
                <v-row class="mt-4" justify="center">
                  <v-col cols="12">

                    <v-row class="my-4" justify="center">
                      <v-col cols="12" md="3" v-for="device in room.images" :key="device.id">
                        <div class="device-item">
                          <p>{{ device.title }}</p>
                          <v-img :src="device.images[0]" eager></v-img>
                          <p>{{ device.description }}</p>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </template>
            </v-col>
          </v-row>
        </v-col>

      </v-row>

    </v-container>
  </div>
</template>

<script>

import roomlist from './data/rooms.js'

export default {
  name: "Facility",
  data: () => ({
    items: [],
    rooms: roomlist.rooms
  }),
  methods: {
    smoothScroll(target) {
      const element = document.getElementById(target);
      const offset = element.offsetTop; // オフセット位置を取得

      window.scrollTo({
        top: offset,
        behavior: 'smooth' // スムーズスクロールを有効にする
    });
    },
  }
};
</script>

<style scoped>
.info {
  text-align: center;
}

.heading {
  border-bottom: 2px solid #000;
}

.submenu {
  position:fixed;
}
</style>